import { getAuthUser } from "../auth/googleAuth";

export const useAuth = () => {
  return getAuthUser();
};
